export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 20;
export const RES_PER_PAGE = 10;
export const KEY = `0b67ef8e-cf73-4f30-9e1e-fd58884f28ca`;
export const MODAL_CLOSE_SEC = 2.5;
